import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MenuItem } from "primeng/api";
import { SubSink } from "subsink/dist/subsink";
import { PpsUtilityService } from "../services/pps-utility.service";
import { ReportService } from "../services/report.service";
import { MonthlyIncomeReportItem } from "../shared/models/monthly-income-report-item";

@Component({
  selector: "pps-monthly-income-report",
  templateUrl: "./monthly-income-report.component.html"
})
export class MonthlyIncomeReportComponent implements OnInit, OnDestroy{
  private subs = new SubSink();
  smallScreen = false;

  items: MenuItem[] = [{label: "Report", icon: "pi-fw fas fa-table"}, {label: "Monthly Income Report", icon: "pi-fw far fa-file-excel"}];
  spinnerName: string = "spinner";
  exporting = false;

  reportItems: MonthlyIncomeReportItem[] = [];
  message: string = "";

  constructor(private _reportService: ReportService,
    private spinner: NgxSpinnerService,
    public util: PpsUtilityService){}

  ngOnInit(): void {
    this.loadReportData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
  
  loadReportData(){
    this.spinner.show(this.spinnerName);
    this.subs.sink = this._reportService.getMonthlyIncomeReportData()
      .subscribe(res => {
        if (res.succeed){
          if (res.result.length === 0){
            this.message = "No data found!";
          }else{
            this.reportItems = res.result;
            let monthTotals = {};

            this.reportItems.forEach(i => {
              i.dateString = i.monthName + ", " + i.year;
              i.dateValue = new Date(i.year, i.month, 1);
              if (monthTotals.hasOwnProperty(i.dateString)){
                monthTotals[i.dateString] += i.invoiceValue;
              }else{
                monthTotals[i.dateString] = i.invoiceValue;
              }
            });

            this.reportItems.forEach(i => i.monthTotal = monthTotals[i.dateString]);

            this.updateRowGroupMetaData();
          }
        }
      }, 
      error => {},
      ()=> {
        this.spinner.hide(this.spinnerName);
      });
  }

  exportToExcel(){
    this.spinner.show(this.spinnerName);
    this.exporting = true;
    this._reportService.generateMonthlyIncomeReport(
      () => {
        this.spinner.hide(this.spinnerName);
        this.exporting = false;
      });
  }
  rowGroupMetadata: any;

  onSort(){
    this.updateRowGroupMetaData();
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};

    if (this.reportItems) {
        for (let i = 0; i < this.reportItems.length; i++) {
            let rowData = this.reportItems[i];
            let groupName = rowData.dateString;
            
            if (i == 0) {
                this.rowGroupMetadata[groupName] = { index: 0, size: 1 };
            }
            else {
                let previousRowData = this.reportItems[i - 1];
                let previousRowGroup = previousRowData.dateString;
                if (groupName === previousRowGroup)
                    this.rowGroupMetadata[groupName].size++;
                else
                    this.rowGroupMetadata[groupName] = { index: i, size: 1 };
            }
        }
    }
  }  
}